import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import './Footer.css'; // Optional, für zusätzliche CSS-Anpassungen

function Footer() {
    return (
            <footer className="footer text-white pt-5">
                <Container>
                    <Row>
                        <Col md={4} className="mb-4 ps-4">
                        <h5 className="text-danger">Über uns</h5>
                        KRAV MAGA FRESENA ist ein Anbegot von Team Schweer Hesel. Das Team Schweer bürgt für:
                        <p className="mt-2">
                        <ul className='mt-2' style={{listStyleType: 'none', padding: 0, textAlign: 'left'}}>
                            <li>✔ Trainerteam mit jahrzehntelange Erfahrung</li>
                            <li>✔ mehrfache Danträger in Kickboxen, Karate</li>
                            <li>✔ Praktiker in TSKM KONTAKTKAMPF</li>
                            <li>✔ Übungsleiter B+C im DOSB</li>
                            <li>✔ zertifizierte Fitnesstrainer</li>
                            <li>✔ 600m² vollmattiertes Kampfsport-Gym</li>
                        </ul>
                        </p>
                        <div className="text-center">
                            <Button className="w-100 mt-2" variant="danger">
                                Erfahre mehr über uns
                            </Button>
                        </div>
                        </Col>
                        <Col md={4} className="mb-4">
                        <div className="d-flex justify-content-center">
                            <img src="./img/KM_FRESENA_BANNER.png" alt="TSKM Kontaktkampf" className="footer-main-logo" />
                        </div>
                        <div className="footer-logos mt-2">
                            <img src="./img/TSKM.png" alt="TSKM Kontaktkampf" className="footer-logo" />
                            <img src="./img/TeamSchweerLogo.png" alt="Team Schweer" className="footer-logo" />
                        </div>
                        </Col>
                        <Col md={4} className="ps-4">
                        <h5 className="text-danger">Kontakt</h5>
                        info@kravmagafresena.de<br/>
                        <div className="social-icons mt-2">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="me-3 text-secondary">
                                <FaFacebook size={24} />
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="me-3 text-secondary">
                                <FaInstagram size={24} />
                            </a>
                            <a href="https://wa.me/123456789" target="_blank" rel="noopener noreferrer" className="text-secondary">
                                <FaWhatsapp size={24} />
                            </a>
                        </div>
                        <h5 className="text-danger mt-3">Team Schweer Hesel</h5>
                        info@teamschweer.de<br/>
                        https://teamschweer.de<br/>
                        Ulmenstrasse 1<br/>
                        26835 Hesel, Ostfriesland<br/>
                        </Col>
                    </Row>
                </Container>
            </footer>
            );
}

export default Footer;
